// Homepage slider: crossfade between slides on a timer, with prev/next arrows.
// Matches the source site's Smart Slider settings -- 800ms crossfade, 5s
// interval, looping -- without pulling in a slider library. Autoplay pauses
// while a mouse is over the slider; the arrows keep working meanwhile.

const INTERVAL = 5000;

export default function slider() {
    const root = document.querySelector('[data-amu-slider]');

    if (!root) {
        return;
    }

    const slides = Array.from(root.querySelectorAll('.amu-slide'));

    if (slides.length < 2) {
        return;
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer = null;
    let hovered = false;

    function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
    }

    function start() {
        if (reduceMotion || hovered) {
            return;
        }
        stop();
        timer = window.setInterval(() => show(current + 1), INTERVAL);
    }

    function stop() {
        if (timer) {
            window.clearInterval(timer);
            timer = null;
        }
    }

    // Advancing by hand restarts the clock so a slide is not cut short.
    root.querySelector('.amu-slider-prev').addEventListener('click', () => {
        show(current - 1);
        start();
    });

    root.querySelector('.amu-slider-next').addEventListener('click', () => {
        show(current + 1);
        start();
    });

    // Mouse only: a tap fires pointerenter with no matching pointerleave, which
    // would leave autoplay stuck off on touch screens.
    root.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') {
            hovered = true;
            stop();
        }
    });

    root.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') {
            hovered = false;
            start();
        }
    });

    // Pause while the tab is hidden so slides do not race through in the
    // background and land on an arbitrary one.
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            stop();
        } else {
            start();
        }
    });

    show(0);
    start();
}
